import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const ContainerButton = styled.div`
	position: fixed;
	bottom: 1rem;
	right: 1rem;
	z-index: 1001;

	/* Efeito de fade-in */
	animation: ${fadeIn} 0.9s ease-in-out;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-family: "MetropolisSemiBold";
	white-space: nowrap;

	button {
		width: 10% !important;
		svg {
			color: #13141b !important;
		}
	}
`;
